import { useQuery } from '@tanstack/react-query';

import { kubesoloTestActive } from '@api/sdk.gen';
import { KubesoloTest } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';
import { isAxiosError } from '@/react/portainer/services/axios/utils/isAxiosError';

import { queryKeys } from './queryKeys';

const POLL_INTERVAL_MS = 3000;

/** The connection test Portainer holds, or null. Polls while machines are queued or running. */
export function useActiveConnectionTest({
  enabled,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.active(),
    queryFn: getActiveConnectionTest,
    refetchInterval: (test) =>
      test && isInProgress(test) ? POLL_INTERVAL_MS : false,
    ...withError('Unable to load the connection test'),
    enabled,
  });
}

export function isInProgress(test: KubesoloTest) {
  return test.counts.queued + test.counts.running > 0;
}

async function getActiveConnectionTest() {
  try {
    const { data } = await kubesoloTestActive();
    return data;
  } catch (error) {
    // no active test is a state the wizard renders, not a failure to notify about
    if (isAxiosError(error) && error.response?.status === 404) {
      return null;
    }

    throw error;
  }
}
